/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import {
  child,
  get,
  getDatabase,
  ref,
  set
} from "firebase/database";

// errors
import ERRORS from "orchestration/firebase-library/errors/Errors.js";

class FirebaseDatabase {
  static app = null;

  static async getDatabase() {
    return getDatabase(FirebaseDatabase.app);
  }

  static async get(domain, childPath) {
    const path = `${domain}/${childPath}`;
    const database = await FirebaseDatabase.getDatabase();
    const dbRef = ref(database);
    const snapshot = await get(child(dbRef, path));
    if(snapshot.exists()) {
      return snapshot.val();
    }
    else {
      throw Error(`${ERRORS.databaseValueNotFound} "${path}"`);
    }
  }

  static async getGlobalValue(childPath) {
    return FirebaseDatabase.get("global", childPath);
  }

  static async set(domain, childPath, payload) {
      const path = `${domain}/${childPath}`;
      const database = await FirebaseDatabase.getDatabase();
      const dbRef = ref(database);
      return set(child(dbRef, path), payload);
  }
}
export default FirebaseDatabase;
